import { getMobileRootPath } from 'utils/mobile'

const {
  NODE_ENV,
  REACT_APP_COMPOSITION,
  REACT_APP_NAME,
  REACT_APP_API_SUBDOMAIN,
  REACT_APP_IS_PULL_REQUEST,
  REACT_APP_MACHINE_ENV,
  REACT_APP_REVIEW_ID,
  REACT_APP_SENTRY_DSN,
  REACT_APP_SENTRY_TRACES_SAMPLE_RATE,
  REACT_APP_THUMBS_URL,
  REACT_APP_VERSION,
} = process.env

export const APP_NAME = REACT_APP_NAME || 'unnamed'
export const VERSION = REACT_APP_VERSION ? `v${REACT_APP_VERSION}` : ''

export const MACHINE_ENV = REACT_APP_MACHINE_ENV || NODE_ENV
export const IS_DEBUG = true
export const IS_DEVELOPMENT = MACHINE_ENV === 'development'
export const IS_TESTING = MACHINE_ENV === 'testing'

const LOCALHOST_API_URL =
  REACT_APP_COMPOSITION === 'test-end2end'
    ? 'http://nginx-test-end2end:80'
    : 'http://localhost'
const DOMAIN_AND_TLD = document.location.hostname.replace(/^.*?\./, '')
const REMOTE_API_URL = `${document.location.protocol}//${REACT_APP_API_SUBDOMAIN}.${DOMAIN_AND_TLD}`

let API_URL
if (REACT_APP_IS_PULL_REQUEST && REACT_APP_REVIEW_ID) {
  API_URL = `https://${APP_NAME}-api-${MACHINE_ENV}-pr${REACT_APP_REVIEW_ID}.osc-fr1.scalingo.io`
} else {
  API_URL = (REACT_APP_API_SUBDOMAIN && REMOTE_API_URL) || LOCALHOST_API_URL
}
export { API_URL, REACT_APP_IS_PULL_REQUEST, REACT_APP_REVIEW_ID }

const LOCALHOST_API_THUMBS_URL = `${LOCALHOST_API_URL}/storage/thumbs`
export const API_THUMBS_URL = REACT_APP_THUMBS_URL || LOCALHOST_API_THUMBS_URL

export const LOCALHOST_ROOT_PATH = 'http://localhost:3000/'
export const ROOT_PATH = getMobileRootPath() || LOCALHOST_ROOT_PATH
export const ROOT_ASSETS_PATH = `${ROOT_PATH}/static/assets`
export const ROOT_LOGO_ICONS_PATH = `${ROOT_PATH}/static/icons`

export const SENTRY_TRACES_SAMPLE_RATE = REACT_APP_SENTRY_TRACES_SAMPLE_RATE
export const SENTRY_DSN = REACT_APP_SENTRY_DSN
